import React, { FC, useState } from "react";
import LocationInput from "../LocationInput";
import { Transition } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { Fragment } from "react";
import FlightDateRangeInput from "./FlightDateRangeInput";
import { GuestsObject } from "components/HeroSearchForm/type";
import NcInputNumber from "components/NcInputNumber/NcInputNumber";
import useOutsideAlerter from "hooks/useOutsideAlerter";
import ButtonSquareFull from "shared/Button/ButtonSqareFull";

export interface FlightSearchFormProps { }

const featuresClass = [
  {
    name: "Beach Front",
    href: "##",
  },
  {
    name: "Pool",
    href: "##",
  },
];

const propertyTypeClass = [
  {
    name: "New Listings",
    href: "##",
  },
  {
    name: "Open Houses",
    href: "##",
  },
  {
    name: "Price Change",
    href: "##",
  },
];


const yearClass = [
  {
    name: "2000s - New",
    href: "##",
  },
  {
    name: "1990s - 1999s",
    href: "##",
  },
];

const FlightSearchForm: FC<FlightSearchFormProps> = () => {
  const [dropOffLocationType, setDropOffLocationType] = useState<
    "roundTrip" | "oneWay" | ""
  >("roundTrip");
  const [featuresClassState, setFeaturesClassState] = useState("Features");
  const [propertyTypeClassState, setPropertyTypeClassState] = useState("Property Type");
  const [yearClassState, setYearClassState] = useState("Years Built");

  // const [guestAdultsInputValue, setGuestAdultsInputValue] = useState(2);
  // const [guestChildrenInputValue, setGuestChildrenInputValue] = useState(1);
  // const [guestInfantsInputValue, setGuestInfantsInputValue] = useState(1);

  //
  const refFeaturesClassContainer = React.createRef<HTMLDivElement>();
  const [openFeaturesClass, setOpenFeaturesClass] = useState(false);
  useOutsideAlerter(refFeaturesClassContainer, () => setOpenFeaturesClass(false));

  const refPropertyTypeClassContainer = React.createRef<HTMLDivElement>();
  const [openPropertyTypeClass, setOpenPropertyTypeClass] = useState(false);
  useOutsideAlerter(refPropertyTypeClassContainer, () => setOpenPropertyTypeClass(false));

  const refYearClassContainer = React.createRef<HTMLDivElement>();
  const [openYearClass, setOpenYearClass] = useState(false);
  useOutsideAlerter(refYearClassContainer, () => setOpenYearClass(false));
  // const handleChangeData = (value: number, type: keyof GuestsObject) => {
  //   let newValue = {
  //     guestAdults: guestAdultsInputValue,
  //     guestChildren: guestChildrenInputValue,
  //     guestInfants: guestInfantsInputValue,
  //   };
  //   if (type === "guestAdults") {
  //     setGuestAdultsInputValue(value);
  //     newValue.guestAdults = value;
  //   }
  //   if (type === "guestChildren") {
  //     setGuestChildrenInputValue(value);
  //     newValue.guestChildren = value;
  //   }
  //   if (type === "guestInfants") {
  //     setGuestInfantsInputValue(value);
  //     newValue.guestInfants = value;
  //   }
  // };

  // const totalGuests =
  //   guestChildrenInputValue + guestAdultsInputValue + guestInfantsInputValue;

  // const renderGuest = () => {
  //   return (
  //     <div className="">
  //       <div ref={refGuestContainer} className="relative">
  //         <>
  //           <div
  //             className={`cursor-pointer px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-0 text-xs`}
  //             onClick={() => setOpenGuest(!openGuest)}
  //           >
  //             <span>{`${totalGuests || ""} Guests`}</span>
  //             <ChevronDownIcon
  //               className={`${
  //                 openGuest ? "" : "text-opacity-70"
  //               } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
  //               aria-hidden="true"
  //             />
  //           </div>
  //           <Transition
  //             show={openGuest}
  //             as={Fragment}
  //             enter="transition ease-out duration-200"
  //             enterFrom="opacity-0 translate-y-1"
  //             enterTo="opacity-100 translate-y-0"
  //             leave="transition ease-in duration-150"
  //             leaveFrom="opacity-100 translate-y-0"
  //             leaveTo="opacity-0 translate-y-1"
  //           >
  //             <div className="absolute z-20 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 left-1/2 -translate-x-1/2  py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl ring-1 ring-black/5 dark:ring-white/10">
  //               <NcInputNumber
  //                 className="w-full"
  //                 defaultValue={guestAdultsInputValue}
  //                 onChange={(value) => handleChangeData(value, "guestAdults")}
  //                 max={10}
  //                 min={1}
  //                 label="Adults"
  //                 desc="Ages 13 or above"
  //               />
  //               <NcInputNumber
  //                 className="w-full mt-6"
  //                 defaultValue={guestChildrenInputValue}
  //                 onChange={(value) => handleChangeData(value, "guestChildren")}
  //                 max={4}
  //                 label="Children"
  //                 desc="Ages 2–12"
  //               />

  //               <NcInputNumber
  //                 className="w-full mt-6"
  //                 defaultValue={guestInfantsInputValue}
  //                 onChange={(value) => handleChangeData(value, "guestInfants")}
  //                 max={4}
  //                 label="Infants"
  //                 desc="Ages 0–2"
  //               />
  //             </div>
  //           </Transition>
  //         </>
  //       </div>
  //     </div>
  //   );
  // };

  const renderPropertyTypeClass = () => {
    return (
      <div className="">
        <div ref={refPropertyTypeClassContainer} className="relative">
          <>
            <div
              className={`px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-0 text-xs`}
              onClick={() => setOpenPropertyTypeClass(!openPropertyTypeClass)}
            >
              <span>{`${propertyTypeClassState}`}</span>
              <ChevronDownIcon
                className={`${openPropertyTypeClass ? "" : "text-opacity-70"
                  } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                aria-hidden="true"
              />
            </div>
            <Transition
              show={openPropertyTypeClass}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <div className="absolute z-30 w-screen max-w-[200px] sm:max-w-[220px] px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0 ">
                <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 dark:ring-white/10 ">
                  <div className="relative grid bg-white dark:bg-neutral-800 p-3">
                    {propertyTypeClass.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        onClick={(e) => {
                          e.preventDefault();
                          setPropertyTypeClassState(item.name);
                          setOpenPropertyTypeClass(false);
                        }}
                        className="flex items-center p-2 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <p className="text-sm font-medium ">{item.name}</p>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </Transition>
          </>
        </div>
      </div>
    );
  };

  const renderYearClass = () => {
    return (
      <div className="">
        <div ref={refYearClassContainer} className="relative">
          <>
            <div
              className={`px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-0 text-xs`}
              onClick={() => setOpenYearClass(!openYearClass)}
            >
              <span>{`${yearClassState}`}</span>
              <ChevronDownIcon
                className={`${openYearClass ? "" : "text-opacity-70"
                  } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                aria-hidden="true"
              />
            </div>
            <Transition
              show={openYearClass}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <div className="absolute z-30 w-screen max-w-[200px] sm:max-w-[220px] px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0 ">
                <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 dark:ring-white/10 ">
                  <div className="relative grid bg-white dark:bg-neutral-800 p-3">
                    {yearClass.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        onClick={(e) => {
                          e.preventDefault();
                          setPropertyTypeClassState(item.name);
                          setOpenPropertyTypeClass(false);
                        }}
                        className="flex items-center p-2 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <p className="text-sm font-medium ">{item.name}</p>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </Transition>
          </>
        </div>
      </div>
    );
  };

  const renderFeaturesClass = () => {
    return (
      <div className="">
        <div ref={refFeaturesClassContainer} className="relative">
          <>
            <div
              className={`px-4 py-1.5 rounded-md inline-flex items-center font-medium hover:text-opacity-100 focus:outline-none focus-visible:ring-0 text-xs`}
              onClick={() => setOpenFeaturesClass(!openFeaturesClass)}
            >
              <span>{`${featuresClassState}`}</span>
              <ChevronDownIcon
                className={`${openFeaturesClass ? "" : "text-opacity-70"
                  } ml-2 h-4 w-4 group-hover:text-opacity-80 transition ease-in-out duration-150`}
                aria-hidden="true"
              />
            </div>
            <Transition
              show={openFeaturesClass}
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"
            >
              <div className="absolute z-30 w-screen max-w-[200px] sm:max-w-[220px] px-4 mt-3 transform -translate-x-1/2 left-1/2 sm:px-0 ">
                <div className="overflow-hidden rounded-2xl shadow-lg ring-1 ring-black/5 dark:ring-white/10 ">
                  <div className="relative grid bg-white dark:bg-neutral-800 p-3">
                    {featuresClass.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        onClick={(e) => {
                          e.preventDefault();
                          setFeaturesClassState(item.name);
                          setOpenFeaturesClass(false);
                        }}
                        className="flex items-center p-2 transition duration-150 ease-in-out rounded-lg hover:bg-neutral-100 dark:hover:bg-gray-700 focus:outline-none focus-visible:ring focus-visible:ring-orange-500 focus-visible:ring-opacity-50"
                      >
                        <p className="text-sm font-medium ">{item.name}</p>
                      </a>
                    ))}
                  </div>
                </div>
              </div>
            </Transition>
          </>
        </div>
      </div>
    );
  };

  const renderRadioBtn = () => {
    return (
      <div className="pb-3 flex justify-center space-x-3">
        {/* <div
          className={`py-1.5 px-4 flex items-center rounded-full font-medium text-xs cursor-pointer select-none ${
            dropOffLocationType === "roundTrip"
              ? "bg-black shadow-black/10 shadow-lg text-white"
              : "border border-neutral-300 dark:border-neutral-700"
          }`}
          onClick={(e) => setDropOffLocationType("roundTrip")}
        >
          Round-trip
        </div>
        <div
          className={`py-1.5 px-4 flex items-center rounded-full font-medium text-xs cursor-pointer select-none ${
            dropOffLocationType === "oneWay"
              ? "bg-black text-white shadow-black/10 shadow-lg"
              : "border border-neutral-300 dark:border-neutral-700"
          }`}
          onClick={(e) => setDropOffLocationType("oneWay")}
        >
          One-way
        </div> */}

        {/* <div className=" border-r border-slate-200 dark:border-slate-700 "></div> */}

        <div className="border border-neutral-300 dark:border-neutral-700 rounded-full">
          {renderFeaturesClass()}
        </div>
        <div className="border border-neutral-300 dark:border-neutral-700 rounded-full">
          {renderPropertyTypeClass()}
        </div>
        <div className="border border-neutral-300 dark:border-neutral-700 rounded-full">
          {renderYearClass()}
        </div>
        {/* <div className="border border-neutral-300 dark:border-neutral-700 rounded-full">
          {renderGuest()}
        </div> */}
      </div>
    );
  };

  const renderForm = () => {
    return (

      <div className="flex flex-row bg-[#EFF7FE] w-full  h-[480px] ">
        <div className="flex-col w-1/3 " >
          <div className="flex-row " >
            <div className="pl-[100px] " >
              <span className=" pt-[30px] block text-4xl font-semibold w-full flex items-center justify-left h-full">Refined Search</span>
              <div className="mt-[30px] mb-[10px]">
                <label className="text-lg font-semibold " htmlFor="">
                  Years built
                </label>
                {/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div> */}
              </div>
              <div className=" grid grid-cols-2 gap-5">

                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Single family"
                    name="Single family"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      2000s - New
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      1990s - 1995s
                    </span>
                  </label>
                </div>
              </div>

              <div className="mt-[30px] mb-[10px]">
                <label className="text-lg font-semibold " htmlFor="">
                  Features
                </label>
                {/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div> */}
              </div>
              <div className=" grid grid-cols-2 gap-5">

                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Single family"
                    name="Single family"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Beach front
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Pool
                    </span>
                  </label>
                </div>

              </div>


              <div className="pt-[140px]" >
                <ButtonSquareFull className="bg-[#00D3DB] text-md font-medium text-[white] px-[18px]"
                  size="h-9" >
                  Update
                </ButtonSquareFull>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-col w-2/3  " >
          <div className="flex flex-row  " >
            <div className="w-[400px] mt-[103px]">
              <div className="mt-[30px] mb-[10px]">
                <label className="text-sm  " htmlFor="">
                  Show only
                </label>
                {/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div> */}
              </div>
              <div className=" grid grid-cols-2 gap-5">

                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Single family"
                    name="Single family"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      New listing
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Price charge
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Open houses
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      All listings
                    </span>
                  </label>
                </div>
              </div>
            </div>




            <div className="ml-[20px] w-[520px] mt-[80px]">
              <div className="mt-[30px] mb-[25px]">
                <label className="text-lg font-semibold " htmlFor="">
                  Property type
                </label>
                {/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div> */}
              </div>
              <div className=" grid grid-cols-3 gap-5">

                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Single family"
                    name="Single family"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Single family
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Apartments
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Villa
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Commercial
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                      Residential rents
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-[15px] mb-[5px]" >
          <label className=" text-lg font-semibold " htmlFor="">
            Additional
          </label>
          </div>
          <div className="flex flex-row " >
            <div className="pr-[15px]" >
              <input
                className={`block w-[135px] bg-white border-none rounded-md pl-[15px] py-[10px] text-xs focus:outline-none focus:placeholder-neutral-300  placeholder-neutral-800  truncate`}
                placeholder="Minimum price"
              //   value={}
              //   autoFocus={}
              //   onChange={(e) => {
              //   }
              // }
              //   ref={}
              />
            </div>
            <div className="pr-[15px]" >
              <input
                className={`block w-[135px] bg-white border-none rounded-md pl-[15px] py-[10px] text-xs focus:outline-none focus:placeholder-neutral-300  placeholder-neutral-800  truncate`}
                placeholder="Maximum price"
              //   value={}
              //   autoFocus={}
              //   onChange={(e) => {
              //   }
              // }
              //   ref={}
              />
            </div>
            <div className="pr-[15px]" >
            <input
              className={`block w-[75px] bg-white border-none rounded-md pl-[15px] py-[10px] text-xs focus:outline-none focus:placeholder-neutral-300  placeholder-neutral-800  truncate`}
              placeholder="beds"
            //   value={}
            //   autoFocus={}
            //   onChange={(e) => {
            //   }
            // }
            //   ref={}
            />
 </div>
 <div className="pr-[15px]" >
            <input
              className={`block w-[75px] bg-white border-none rounded-md pl-[15px] py-[10px] text-xs focus:outline-none focus:placeholder-neutral-300  placeholder-neutral-800  truncate`}
              placeholder="baths"
            //   value={}
            //   autoFocus={}
            //   onChange={(e) => {
            //   }
            // }
            //   ref={}
            />
 </div>
 <div className="pr-[15px]" >
            <input
              className={`block w-[145px] bg-white border-none rounded-md pl-[15px] py-[10px] text-xs focus:outline-none focus:placeholder-neutral-300  placeholder-neutral-800  truncate`}
              placeholder="keywords"
            //   value={}
            //   autoFocus={}
            //   onChange={(e) => {
            //   }
            // }
            //   ref={}
            />
 </div>


          </div>
          <div className="mt-[25px] mb-[10px]">
                <label className="text-lg font-semibold " htmlFor="">
                Investment property
                </label>
                {/* <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div> */}
              </div>
              <div className="w-[450px] grid grid-cols-2 gap-5">

                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Single family"
                    name="Single family"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                    Long term rental
                    </span>
                  </label>
                </div>
                <div className={`flex text-sm sm:text-base`}>
                  <input
                    id="Duplex"
                    name="Duplex"
                    type="checkbox"
                    className="focus:ring-action-primary h-6 w-6 text-primary-500 border-primary rounded border-neutral-500 bg-white dark:bg-neutral-700  dark:checked:bg-primary-500 focus:ring-primary-500"
                  // onChange={handleCheckboxHouseItems}
                  />
                  <label
                    className="ml-3.5 flex flex-col flex-1 justify-center"
                  >
                    <span className=" text-neutral-900 dark:text-neutral-100">
                    Airbnb
                    </span>
                  </label>
                </div>

              </div>
        </div>

        {/* <form className="w-full relative  "> */}
        {/* {renderRadioBtn()}
        {renderRadioBtn()}
        {renderRadioBtn()} */}
        {/* <div className="flex w-full rounded-full border border-neutral-200 dark:border-neutral-700 bg-white dark:bg-neutral-800"> */}
        {/* <LocationInput
            placeHolder="Property Address"
            desc="Where do you want to search?"
            className="flex-1"
          />  */}
        {/* <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
          <LocationInput
            placeHolder="Flying to"
            desc="Where you want to fly to?"
            className="flex-1"
            divHideVerticalLineClass=" -inset-x-0.5"
          /> 
           <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
          <FlightDateRangeInput
            selectsRange={dropOffLocationType !== "oneWay"}
            className="flex-1"
          />  */}
        {/* </div> */}
      </div>
    );
  };

  return (
    <div className="">
      {renderForm()}
    </div>
  );
};

export default FlightSearchForm;
